ACC.dkgProcessingCustDimButton = {
    bind: function() {
        $(document).on('click', '.dkg-custom-variant', this.handleCustDimClick.bind(this));
    },
    initCustDimButton: function() {
        if (!$('.dkg-custom-variant').length) {
            return;
        }

        var allDimensionsLength = $('.js-product-variant-div .dim-heading').length;
        var allSelectedDimensionsLength = $('.js-product-variant-div .dim-label.selected').length;
        var isCustomisableDimensionSelected = !!$('.dim-wrapper-L .dim-label.selected').length;
        if (allDimensionsLength - allSelectedDimensionsLength == (isCustomisableDimensionSelected ? 0 : 1)) {
            $('.dkg-custom-variant').removeClass('not-active');
        } else {
            $('.dkg-custom-variant').addClass('not-active');
        }
        if (!$('.dim-wrapper-L .dim-label:not(.selected)').length) {
            this.resetToDefault();
        }
        ACC.dkgProcessingValidations.maxCustomLengthValue = null;
    },
    handleCustDimClick: function(e) {
        var button = $('.dkg-custom-variant-selection');
        if (button.data('state') === 'selected' || button.hasClass('selected')) {
            this.resetToDefault();
        } else {
            ACC.dkgProcessing.openCustomDimensionOverlay(e);
        }
    },
    markAsFigureCut: function() {
        this.unclickOtherSelectedDimension();
        var button = $('.dkg-custom-variant');
        button.addClass('dkg-custom-variant-selection selected').attr('data-state', 'selected');
        var customCutText = button.data('selected-text');
        $('.dkg-custom-variant .reset-icon').removeClass('hide');
        $('.dkg-custom-variant .value').text(customCutText);
    },
    markAsFixCut: function(length) {
        this.unclickOtherSelectedDimension();
        $('.dkg-custom-variant').addClass('dkg-custom-variant-selection selected').attr('data-state', 'selected');
        $('.dkg-custom-variant .reset-icon').removeClass('hide');
        $('.dkg-custom-variant .value').text(length);
    },
    unclickOtherSelectedDimension: function() {
        var selectedOption = $('.dim-wrapper-L .dim-label.selected');
        if(selectedOption.length) {
            var $this = $(selectedOption[0]);

            selectVariantDimension({"target": $this.find('span')[0], "preventDefault": function(){}}, $this.attr('id'), true, true);
        }
    },
    resetToDefault: function() {
        var button = $('.dkg-custom-variant');
        ACC.productDetail.removeCustomDimension();
        $('.custom-dimension-input').val("");
        button.find('.value').text(button.attr('data-placeholder'));
        button.removeClass('dkg-custom-variant-selection').removeClass('selected');
        ACC.dkgProcessing.saveAddToCartFields("", "", "", "", "", "");
        ACC.dkgProcessing.hideMiterSawingSummary();
        ACC.dkgProcessing.showFavoriteToggle();
    }
}

$(document).ready(function() {
    if ($('.dkg-custom-variant').length) {
        ACC.dkgProcessingCustDimButton.bind();
    }
});
